import {
    createAsyncThunk,
    createSlice,
    PayloadAction,
} from '@reduxjs/toolkit'
import api from '../../utils/api'
import { RetrieveMapSpaceResponse } from '../../types/swagger'
import { RootState } from '../../store'

export const fetchMap = createAsyncThunk(
    'fetchMap',
    async (args: { eventSlug: string, slug: string }) => {
        const url = `/events/${args.eventSlug}/organizer/maps/${args.slug}/`
        const map = await api.get<RetrieveMapSpaceResponse>(url)
        return map as RetrieveMapSpaceResponse
    },
)

type MapMode = 'viewing' | 'editing'

const mapSlice = createSlice({
    name: 'mapSlice',
    initialState: {
        data: {} as RetrieveMapSpaceResponse,
        generatedIdsToItemIds: {} as Record<number, number>,
        mode: 'viewing' as MapMode,
        isZooming: false
    },
    reducers: {
        changeMode(state, { payload }: PayloadAction<MapMode>) {
            state.mode = payload
        },
        updateIsZooming(state, { payload }: PayloadAction<boolean>) {
            state.isZooming = payload
        }
    },
    extraReducers: (builder) => builder
        .addCase(fetchMap.fulfilled, (state, { payload }) => {
            state.data = payload
        })
})

export const selectMapData = (state: RootState) => state.map?.data
export const modeSelector = (state: RootState) => state.map?.mode
export const isZoomingSelector = (state: RootState) => state.map?.isZooming

export const changeMode = mapSlice.actions.changeMode
export const updateIsZooming = mapSlice.actions.updateIsZooming

export default mapSlice.reducer
